<template>
  <v-container id="clientAboutBackgrounds" class="pa-0 pb-5">
    <v-progress-linear indeterminate
      v-if="isAllLoading"
      class="ma-0"
      color="blue"
    />
    <v-card flat max-width="600" class="mx-auto transparent">
      <v-form v-show="!isAllLoading" ref="form" v-model="form.valid">
        <v-list class="pa-2">
          <v-subheader class="abt-item px-3">パスポート</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsPassport v-for="item in store.passports" :key="item.id" class="abt-item px-3 my-3" ref="passport"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">ビザ</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsVisa v-for="item in getCurrentVisaItems" :key="item.id" class="abt-item px-3 my-3" ref="visa"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">ビザ取得歴</v-subheader>
          <ClientAboutBackgroundsVisa v-for="item in getPastVisaItems" :key="item.id" class="abt-item px-3 my-3" ref="visa_history"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBackgroundsVisaInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">渡航歴</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsTravel v-for="item in getTravelItems" :key="item.id"
            class="abt-item px-3 my-3"
            ref="travel"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBackgroundsTravelInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">語学力</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsLang v-for="item in getLangItems" :key="item.id"
            class="abt-item px-3 my-3"
            ref="lang"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBackgroundsLangInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">語学資格</v-subheader>
          <ClientAboutBackgroundsCert v-for="item in getCertItems" :key="item.id"
            class="abt-item px-3 my-3"
            ref="cert"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBackgroundsCertInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">学歴</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsCareer v-for="item in getCareerItems" :key="item.id"
            class="abt-item px-3 my-3"
            ref="career"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBackgroundsCareerInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-subheader class="abt-item px-3">既往症</v-subheader>
          <v-divider class="abt-item px-3" />
          <ClientAboutBackgroundsMedical v-for="item in getMedicalItems" :key="item.id"
            class="abt-item px-3 my-3"
            ref="medical"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
        </v-list>
        <v-subheader class="abt-item px-3 mt-4">ホームステイに必要な情報</v-subheader>
        <v-list class="pa-2">
          <ClientAboutBackgroundsHomestaySmoke
            class="abt-item px-3 my-3"
            ref="smoke"
            :status="getStatus"
            :data="getSmokeData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayHobby
            class="abt-item px-3 my-3"
            ref="hobby"
            :status="getStatus"
            :data="getHobbyData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayAllergy
            class="abt-item px-3 my-3"
            ref="allergy"
            :status="getStatus"
            :data="getAllergyData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayReligion
            class="abt-item px-3 my-3"
            ref="religion"
            :status="getStatus"
            :data="getReligionData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayKids
            class="abt-item px-3 my-3"
            ref="kids"
            :status="getStatus"
            :data="getKidsData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayPets
            class="abt-item px-3 my-3"
            ref="pets"
            :status="getStatus"
            :data="getPetsData"
            @emit="emitted"
          />
          <ClientAboutBackgroundsHomestayNotes
            class="abt-item px-3 my-3"
            ref="notes"
            :status="getStatus"
            :data="getNotesData"
            @emit="emitted"
          />
        </v-list>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import ClientAboutBackgroundsPassport from './components/passport'
import ClientAboutBackgroundsVisa from './components/visa'
import ClientAboutBackgroundsVisaInsert from './components/visa/modals/insert'
import ClientAboutBackgroundsTravel from './components/travel'
import ClientAboutBackgroundsTravelInsert from './components/travel/modals/insert'
import ClientAboutBackgroundsLang from './components/lang'
import ClientAboutBackgroundsLangInsert from './components/lang/modals/insert'
import ClientAboutBackgroundsCert from './components/cert'
import ClientAboutBackgroundsCertInsert from './components/cert/modals/insert'
import ClientAboutBackgroundsCareer from './components/career'
import ClientAboutBackgroundsCareerInsert from './components/career/modals/insert'
import ClientAboutBackgroundsMedical from './components/medical'

import ClientAboutBackgroundsHomestaySmoke from './components/homestay/smoke'
import ClientAboutBackgroundsHomestayHobby from './components/homestay/hobby'
import ClientAboutBackgroundsHomestayAllergy from './components/homestay/allergy'
import ClientAboutBackgroundsHomestayReligion from './components/homestay/religion'
import ClientAboutBackgroundsHomestayKids from './components/homestay/kids'
import ClientAboutBackgroundsHomestayPets from './components/homestay/pets'
import ClientAboutBackgroundsHomestayNotes from './components/homestay/notes'

const DEFAULT = {
  STATUS: {
    LOADING: 'all',
    EDITING: '',
    SUBMITTING: ''
  },
  FORM: {
    ITEM: {
      DEFAULT: JSON.stringify({
        value: '',
        required: false
      }),
      REQUIRED: JSON.stringify({
        value: '',
        required: true
      })
    }
  }
}
export default {
  name: 'clientAboutBackgrounds',
  components: {
    ClientAboutBackgroundsPassport,
    ClientAboutBackgroundsVisa,
    ClientAboutBackgroundsVisaInsert,
    ClientAboutBackgroundsTravel,
    ClientAboutBackgroundsTravelInsert,
    ClientAboutBackgroundsLang,
    ClientAboutBackgroundsLangInsert,
    ClientAboutBackgroundsCert,
    ClientAboutBackgroundsCertInsert,
    ClientAboutBackgroundsCareer,
    ClientAboutBackgroundsCareerInsert,
    ClientAboutBackgroundsMedical,
    ClientAboutBackgroundsHomestaySmoke,
    ClientAboutBackgroundsHomestayHobby,
    ClientAboutBackgroundsHomestayAllergy,
    ClientAboutBackgroundsHomestayReligion,
    ClientAboutBackgroundsHomestayKids,
    ClientAboutBackgroundsHomestayPets,
    ClientAboutBackgroundsHomestayNotes
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          editing: DEFAULT.STATUS.EDITING
        }
      },
      form: {
        valid: true
      },
      store: {
      }
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$nextTick(() => {
        this.get()
      })
    },
    get: function (type) {
      this.$set(this.config.status, 'loading', type != null ? type : 'all')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: true
        }
      })
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}about/get/backgrounds`, {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', '')
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'loading',
              status: false
            }
          })
          if (res.data && res.data.success) {
            this.$set(this, 'store', res.data.data)
          }
        })
      })
    },
    prepare: function () {
      if (this.$refs.passport) {
        for (let i = 0; i < this.$refs.passport.length; i++) {
          this.$refs.passport[i].prepare()
        }
      }
      if (this.$refs.visa) {
        for (let i = 0; i < this.$refs.visa.length; i++) {
          this.$refs.visa[i].prepare()
        }
      }
      if (this.$refs.visa_history) {
        for (let i = 0; i < this.$refs.visa_history.length; i++) {
          this.$refs.visa_history[i].prepare()
        }
      }
      if (this.$refs.travel) {
        for (let i = 0; i < this.$refs.travel.length; i++) {
          this.$refs.travel[i].prepare()
        }
      }
      if (this.$refs.lang) {
        for (let i = 0; i < this.$refs.lang.length; i++) {
          this.$refs.lang[i].prepare()
        }
      }
      if (this.$refs.cert) {
        for (let i = 0; i < this.$refs.cert.length; i++) {
          this.$refs.cert[i].prepare()
        }
      }
      if (this.$refs.career) {
        for (let i = 0; i < this.$refs.career.length; i++) {
          this.$refs.career[i].prepare()
        }
      }
      if (this.$refs.medical) {
        for (let i = 0; i < this.$refs.medical.length; i++) {
          this.$refs.medical[i].prepare()
        }
      }
      if (this.$refs.smoke) {
        this.$refs.smoke.prepare()
      }
      if (this.$refs.hobby) {
        this.$refs.hobby.prepare()
      }
      if (this.$refs.allergy) {
        this.$refs.allergy.prepare()
      }
      if (this.$refs.religion) {
        this.$refs.religion.prepare()
      }
      if (this.$refs.kids) {
        this.$refs.kids.prepare()
      }
      if (this.$refs.pets) {
        this.$refs.pets.prepare()
      }
      if (this.$refs.notes) {
        this.$refs.notes.prepare()
      }
      this.edit()
    },
    edit: function (req) {
      const { id, type } = req || {}
      if (this.config.status.editing) {
        this.submit({ type: 'series' })
      }
      if (id) {
        this.$set(this.config.status, 'editing', id)
      } else if (type) {
        this.$set(this.config.status, 'editing', type)
      } else {
        this.$set(this.config.status, 'editing', 'all')
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: true
        }
      })
    },
    insert: function (req) {
      const { type, resolve } = req
      if (type && resolve) {
        if (this.store[type]) {
          this.store[type].push(resolve)
          this.$nextTick(() => {
            if (type === 'visas') {
              this.$refs.visa_history[this.$refs.visa_history.length - 1].prepare()
            } else if (type === 'travels') {
              this.$refs.travel[this.$refs.travel.length - 1].prepare()
            } else if (type === 'langs') {
              this.$refs.lang[this.$refs.lang.length - 1].prepare()
            } else if (type === 'certs') {
              this.$refs.cert[this.$refs.cert.length - 1].prepare()
            } else if (type === 'careers') {
              this.$refs.career[this.$refs.career.length - 1].prepare()
            } else if (type === 'medicals') {
              this.$refs.medical[this.$refs.medical.length - 1].prepare()
            }
          })
        }
      }
    },
    remove: function (req) {
      if (
        req &&
        req.id &&
        req.type &&
        this.store[req.type] &&
        this.store[req.type].length
      ) {
        let idx = this.store[req.type].findIndex(it => {
          return it.id === req.id
        })
        if (idx >= 0) {
          this.store[req.type].splice(idx, 1)
        }
      }
    },
    preSubmit: function (req) {
      const { type } = req
      const urls = {
        update: `${this.$url.api}about/update/backgrounds`,
        series: `${this.$url.api}about/update/backgrounds`
      }
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          passports: [],
          visas: [],
          travels: [],
          langs: [],
          certs: [],
          careers: [],
          medicals: []
        }
        if (this.config.status.editing === 'all') {
          for (let i = 0; i < this.$refs.passport.length; i++) {
            fd.passports.push(this.$refs.passport[i].getForm())
          }
          for (let i = 0; i < this.$refs.visa.length; i++) {
            fd.visas.push(this.$refs.visa[i].getForm())
          }
          for (let i = 0; i < this.$refs.travel.length; i++) {
            fd.travels.push(this.$refs.travel[i].getForm())
          }
          for (let i = 0; i < this.$refs.lang.length; i++) {
            fd.langs.push(this.$refs.lang[i].getForm())
          }
          for (let i = 0; i < this.$refs.cert.length; i++) {
            fd.certs.push(this.$refs.cert[i].getForm())
          }
          for (let i = 0; i < this.$refs.career.length; i++) {
            fd.careers.push(this.$refs.career[i].getForm())
          }
          for (let i = 0; i < this.$refs.medical.length; i++) {
            fd.medicals.push(this.$refs.medical[i].getForm())
          }
        }
        if (this.config.status.editing.indexOf('passport_') >= 0) {
          let idx = this.$refs.passport.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.passports.push(this.$refs.passport[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('visa_') >= 0) {
          let idx = this.$refs.visa.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.visas.push(this.$refs.visa[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('travel_') >= 0) {
          let idx = this.$refs.travel.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.travels.push(this.$refs.travel[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('lang_') >= 0) {
          let idx = this.$refs.lang.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.langs.push(this.$refs.lang[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('cert_') >= 0) {
          let idx = this.$refs.cert.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.certs.push(this.$refs.cert[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('career_') >= 0) {
          let idx = this.$refs.career.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.careers.push(this.$refs.career[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('medical_') >= 0) {
          let idx = this.$refs.medical.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.medicals.push(this.$refs.medical[idx].getForm())
          }
        }
        if (['smoke', 'all'].includes(this.config.status.editing) && this.$refs.smoke) {
          fd.smoke = this.$refs.smoke.getForm()
        }
        if (['hobby', 'all'].includes(this.config.status.editing) && this.$refs.hobby) {
          fd.hobby = this.$refs.hobby.getForm()
        }
        if (['allergy', 'all'].includes(this.config.status.editing) && this.$refs.allergy) {
          fd.allergy = this.$refs.allergy.getForm()
        }
        if (['religion', 'all'].includes(this.config.status.editing) && this.$refs.religion) {
          fd.religion = this.$refs.religion.getForm()
        }
        if (['kids', 'all'].includes(this.config.status.editing) && this.$refs.kids) {
          fd.kids = this.$refs.kids.getForm()
        }
        if (['pets', 'all'].includes(this.config.status.editing) && this.$refs.pets) {
          fd.pets = this.$refs.pets.getForm()
        }
        if (['notes', 'all'].includes(this.config.status.editing) && this.$refs.notes) {
          fd.notes = this.$refs.notes.getForm()
        }
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: true
          }
        })
        if (type && urls[type]) {
          const url = urls[type]
          return { url, fd, type }
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const { type } = req || { type: 'update' }
      const dt = this.preSubmit({ type })
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type } = req || {}
      if (type !== 'series') {
        this.$set(this.config.status, 'editing', '')
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'editing',
            status: false
          }
        })
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.get(this.config.status.editing)
    },
    failSubmit: function () {
      this.$set(this.config.status, 'editing', '')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: false
        }
      })
    },
    close: function () {
      this.$set(this.form, 'valid', true)
      this.$set(this.config.status, 'editing', '')
    },
    emitted: function (req) {
      if (req && req.action) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isEditing () {
      return this.config.status.editing
    },
    isAllEditing () {
      return this.config.status.editing === 'all'
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isAllLoading () {
      return this.config.status.loading === 'all'
    },
    getStatus () {
      return this.config.status
    },
    getData () {
      return this.store
    },
    getAddressItems () {
      return (
        this.store.addresses
      ) ? this.store.addresses : []
    },
    getCurrentVisaItems () {
      let valid = ['', 'YES', 'NO', 'PROGRESS', 'UNNECESSARY']
      return (
        this.store.visas
      ) ? this.store.visas.filter(it => {
          return (
            it.status != null && valid.includes(it.status)
          )
        }) : []
    },
    getPastVisaItems () {
      return (
        this.store.visas
      ) ? this.store.visas.filter(it => {
          return (
            it.status && it.status === 'DONE'
          )
        }) : []
    },
    getTravelItems () {
      return (
        this.store.travels
      ) ? this.store.travels : []
    },
    getLangItems () {
      return (
        this.store.langs
      ) ? this.store.langs : []
    },
    getCertItems () {
      return (
        this.store.certs
      ) ? this.store.certs : []
    },
    getCareerItems () {
      return (
        this.store.careers
      ) ? this.store.careers : []
    },
    getMedicalItems () {
      return (
        this.store.medicals
      ) ? this.store.medicals : []
    },
    getSmokeData () {
      return this.store.smoke || {}
    },
    getHobbyData () {
      return this.store.hobby || {}
    },
    getAllergyData () {
      return this.store.allergy || {}
    },
    getReligionData () {
      return this.store.religion || {}
    },
    getKidsData () {
      return this.store.kids || {}
    },
    getPetsData () {
      return this.store.pets || {}
    },
    getNotesData () {
      return this.store.notes || {}
    }
  }
}
</script>

<style lang="scss">
#clientAboutBackgrounds {
}
</style>

